
import { differenceInSeconds } from 'date-fns';
import { ModelOrigin } from 'src/app/interfaces/api/model';
import { Track } from 'src/app/interfaces/api/track';
import { Position } from 'src/app/interfaces/shared/position';
import * as THREE from "three";
import * as Tools from "../shared/threeDTools";
export class MapCollider {
    mapPolygon: any;
    XYOrigin;
    latLonPolygon: any[] = [];
    localXYPolygon: any[] = [];
    XYPolygon = [];
    unit;
    polygonOptions = {};
    map: any;
    type = "polygon";
    circleRadius = 1;
    lastTrack: any;
    mesh: any;
    extrapolationCoef: number = 5;
    prevAngle: number = 0;
    vertices: any[] = [];
    center: any;
    origin: ModelOrigin;
    constructor(options: any) {
        this.XYOrigin = options.XYOrigin;
        this.unit = options.unit;
        this.extrapolationCoef = this.unit.collider.extrapolationCoef;
        this.origin = options.origin;
    }

    public init(map = null) {
        this.buildPolygon();
        this.map = map;
        if (this.mapPolygon) {

            let geometry = this.unit.collider.geometry;
            if (geometry == "Sphere") {
                this.circleRadius = this.unit.collider.radius || 1;
                this.mapPolygon.setRadius(this.circleRadius)
            }
            if (geometry == "Cylinder") {
                this.circleRadius = this.unit.collider.topradius || 1;
                this.mapPolygon.setRadius(this.circleRadius)
            }
            if (this.mapPolygon.setStrokeColor) {
                this.mapPolygon.setStrokeColor(this.unit.color)
                this.mapPolygon.setFillColor(this.unit.color)
            } else {
                this.mapPolygon.strokeColor = this.unit.color;
                this.mapPolygon.fillColor = this.unit.color;
            }
        }

    }

    buildPolygon() {
        this.localXYPolygon = [];
        const segments = 8;
        let position = new THREE.Vector3(0, 0, 0);
        let geometry = this.unit.collider;

        switch (this.unit.collider.geometry) {
            case 'Point':
                //no geometry to return
                this.localXYPolygon = [];
                break;
            case 'Sphere':
                for (let s = 0; s <= segments; s++) {

                    let vertex = new THREE.Vector3(0, 0, 0);
                    const segment = s / segments * (Math.PI * 2);
                    vertex.x += parseFloat(geometry.radius || 1) * Math.cos(segment);
                    vertex.y += parseFloat(geometry.radius || 1) * Math.sin(segment);

                    this.localXYPolygon.push(vertex);

                }
                this.circleRadius = geometry.radius || 1;
                this.type = "circle";
                break;
            case 'Cylinder':
                for (let s = 0; s <= segments; s++) {

                    let vertex = new THREE.Vector3(0, 0, 0);
                    const segment = s / segments * (Math.PI * 2);
                    vertex.x += parseFloat(geometry.topradius || 1) * Math.cos(segment);
                    vertex.y += parseFloat(geometry.topradius || 1) * Math.sin(segment);

                    this.localXYPolygon.push(vertex);

                }

                this.circleRadius = geometry.topradius || 1;
                this.type = "circle";
                break;
            case 'Box':
                let length = geometry.length || 1;
                let _width = geometry.width || 1;
                this.localXYPolygon = [
                    new THREE.Vector3(position.x - (length * .5), position.y + (_width * .5), 0),
                    new THREE.Vector3(position.x + (length * .5), position.y + (_width * .5), 0),
                    new THREE.Vector3(position.x + (length * .5), position.y - (_width * .5), 0),
                    new THREE.Vector3(position.x - (length * .5), position.y - (_width * .5), 0)
                ]
                this.center = new THREE.Vector3(0, 0, 0)
                break;
            case 'Crane':
                let crane = this.unit.crane;
                let width = crane.width ? crane.width * .5 : 1;
                this.localXYPolygon = [
                    new THREE.Vector3(position.x - (crane.counterJibLength || 0), position.y + width, 0),
                    new THREE.Vector3(position.x + crane.jibLength, position.y + width, 0),
                    new THREE.Vector3(position.x + crane.jibLength, position.y - width, 0),
                    new THREE.Vector3(position.x - (crane.counterJibLength || 0), position.y - width, 0)
                ]
                break;
            default:
                break;
        }
        return this.localXYPolygon;
    }

    alignToDirection(prevTrack: Track, track: Track) {

        let center = new THREE.Vector3(prevTrack.x, prevTrack.y, 0);
        let targetVec = new THREE.Vector3(track.x, track.y, 0);
        let angle = 0;

        let relativeTarget = targetVec.sub(center);
        angle = Tools.lookAt(new THREE.Vector3(1, 0, 0), relativeTarget);

        return angle;

    }

    getSpeed(track: Track) {
        if (!this.lastTrack) return 0;
        differenceInSeconds
        let timeDiff = differenceInSeconds(new Date(track.createdDate), new Date(this.lastTrack.createdDate)) / 1000;

        let target = new THREE.Vector3(track.x, track.y, track.z);
        let dist = target.distanceTo(new THREE.Vector3(this.lastTrack.x, this.lastTrack.y, this.lastTrack.z));
        if (!timeDiff || dist < .5) return 0;

        let speed = dist / timeDiff;
        return speed;
    }

    getStopDistance(speed: number) {
        return (speed * 3.6 / this.extrapolationCoef) ** 2;
    }

    transformWithSpeed(track: Track) {
        let speed = this.getSpeed(track)
        let stopDist = this.getStopDistance(speed);

        let vertices: any[] = [];

        let angle = 0;
        if (this.lastTrack) {
            angle = this.alignToDirection(this.lastTrack, track);
        }

        this.localXYPolygon.forEach((v, i) => {

            let vec;
            if (v.x > this.center.x) {
                vec = new THREE.Vector3(v.x + stopDist, v.y, 1);
            } else {
                vec = new THREE.Vector3(v.x, v.y, 1);
            }

            if (angle && speed) {
                vec.applyAxisAngle(new THREE.Vector3(0, 0, 1), angle);
            } else {
                vec.applyAxisAngle(new THREE.Vector3(0, 0, 1), this.prevAngle);
            }
            vertices.push(vec)
        })
        if (speed)
            this.prevAngle = angle;

        return vertices;

    }

    updateLatLonPosition(track: Track) {

        let XYPos = Tools.getXYFromLatLonAlt2(track.lat, track.lon, 0);
        track.x = XYPos[0] ?? 0;
        track.y = XYPos[1] ?? 0;
        if (this.unit.collider.geometry == "Box") {
            let polygon = this.transformWithSpeed(track)
            this.lastTrack = track;
            this.latLonPolygon = polygon.map(p => {
                let X = (XYPos[0] ?? 0) + p.x;
                let Y = (XYPos[1] ?? 0) + p.y;
                let latLon = Tools.getLatLonFromXYZ(X, Y, 0)
                return new google.maps.LatLng(latLon[1] ?? 0, latLon[0] ?? 0)
            })
        } else {

            this.latLonPolygon = this.localXYPolygon.map(p => {
                let X = (XYPos[0] ?? 0) + p.x;
                let Y = (XYPos[1] ?? 0) + p.y;
                let latLon = Tools.getLatLonFromXYZ(X, Y, 0)
                return new google.maps.LatLng(latLon[1] ?? 0, latLon[0] ?? 0)
            })
        }

        if (this.mapPolygon) {
            if (this.type == "circle") {

                this.mapPolygon.setCenter(new google.maps.LatLng(track.lat, track.lon))

            } else {

                this.mapPolygon.setPaths(this.latLonPolygon)
            }

        }
        return this.latLonPolygon;
    }

    updateLatLonRotation(pos: Position, target: Position) {

        let XYPos = Tools.getXYFromLatLonAlt(pos.lat, pos.lon, 0,);
        let XYTarget = Tools.getXYFromLatLonAlt(target.lat, target.lon, 0);

        let center = new THREE.Vector3(XYPos[0] ?? 0, XYPos[1] ?? 0, 0);
        let targetVec = new THREE.Vector3(XYTarget[0] ?? 0, XYTarget[1] ?? 0, 0);
        let angle = 0;

        let relativeTarget = targetVec.sub(center);
        angle = Tools.lookAt(new THREE.Vector3(1, 0, 0), relativeTarget);

        let targetDist;
        let crane = this.unit.crane;

        if (this.unit.collider.geometry == "Crane" && (crane.fromTracker || crane.type == "mobile" || crane.type == "luffing")) {
            let xDist = (XYTarget[0] ?? 0) - (XYPos[0] ?? 0);
            let yDist = (XYTarget[1] ?? 0) - (XYPos[1] ?? 0);
            targetDist = Math.abs(Math.sqrt(xDist ** 2 + yDist ** 2));

            let width = crane.width ? crane.width * .5 : 1;
            this.localXYPolygon = [
                new THREE.Vector3((crane.counterJibLength || 0) * -1, width, 0),
                new THREE.Vector3((targetDist || crane.jibLength), width, 0),
                new THREE.Vector3((targetDist || crane.jibLength), width * -1, 0),
                new THREE.Vector3((crane.counterJibLength || 0) * -1, width * -1, 0)
            ]
        }

        this.latLonPolygon = this.localXYPolygon.map(p => {
            let vec = new THREE.Vector3(p.x, p.y, 1)
            vec.applyAxisAngle(new THREE.Vector3(0, 0, 1), angle);
            let X = (XYPos[0] ?? 0) + vec.x;
            let Y = (XYPos[1] ?? 0) + vec.y;
            let latLon = Tools.getLatLonFromXYZ(X, Y, 0)
            return new google.maps.LatLng(latLon[1] ?? 0, latLon[0] ?? 0)
        })

        if (this.mapPolygon) {
            this.mapPolygon.setPaths(this.latLonPolygon)
        }
        return this.latLonPolygon;
    }

    getPolygonOptions(map: any) {

        if (!this.latLonPolygon.length) {
            console.error("Error: Polygon is empty")
            return {};
        }

        this.polygonOptions = {
            center: new google.maps.LatLng(this.unit.lastPosition.lat, this.unit.lastPosition.lon),
            points: this.latLonPolygon,
            radius: this.circleRadius || 1,
            strokeColor: this.unit.color || "#FF0000",
            strokeOpacity: 0.8,
            strokeWidth: 1,
            fillColor: this.unit.color || "#FF0000",
            fillOpacity: 0.35,
            zIndex: Math.floor(Math.random() * 100),
            map: this.map.googleMap
        };

        return this.polygonOptions;
    }

    reset() {
        this.mapPolygon.setPoints([]);
        this.mapPolygon.remove();
        if (this.map)
            this.addToMap(this.map)
    }
    addToMap(map: any) {
        try {

            this.map = map;
            if (!map && this.mapPolygon) {
                this.mapPolygon.setMap(null);
            } else if (this.type == "circle") {
                // this.mapPolygon = new google.maps.Circle(this.getPolygonOptions(this.map))
            }
            else if (this.map) {
                this.mapPolygon = new google.maps.Polygon({
                    paths: this.latLonPolygon,
                    strokeColor: this.unit.color || "#FF0000",
                    fillColor: this.unit.color || "#FF0000",
                    strokeWeight: 1,
                    strokeOpacity: 0.8,
                    fillOpacity: 0.35
                });
                this.mapPolygon.setMap(this.map.googleMap)
            }

        } catch (e) {
            console.error(e)
        }
    }
}